export default {"src":"/_next/static/media/eye-black.1e61d76b.svg","height":512,"width":576,"blurWidth":0,"blurHeight":0};